import { importActions } from '../../services';

export const importReducer = ( state = {}, action ) => {
  switch ( action.type ) {
    case importActions.LOAD:
      return action.data;
    default:
      return state;
  }
};
